import React from 'react';
import block from 'bem-cn';
import { useSelector, shallowEqual } from 'react-redux';
import { shortLanguages } from 'services/locale';

import './CashbackTerms.scss';
import Button from 'components/Button';

const b = block('cashback-terms-desktop');

const CashbackTerms = ({ closeFunction }) => {
  const locale = useSelector(state => state.locale.locale);
  const { cashbackConditions } = useSelector(state => state.auth);
  const lang = useSelector(state => state.locale.lang, shallowEqual);

  return (
    <div className={b()}>
      <div className={b('title')}>{cashbackConditions?.[shortLanguages[lang]]}</div>
      <div className={b('button')}>
        <Button text={locale.close} callBack={closeFunction} />
      </div>
    </div>
  );
};

export default CashbackTerms;
